import Axios from 'axios';
import _ from 'lodash';

const url = process.env.NEXT_PUBLIC_SORRA_API_GO_HOST;
const go_api = Axios.create({
  baseURL: url,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const swrGoFetcher = async (url, token) => {
  let headers = {};
  if (_.isFunction(token)) {
    headers = await token();
  } else if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return go_api.get(url, { headers }).then((res) => {
    return res.data.data;
  });
};

export default go_api;
